import { render, staticRenderFns } from "./Aside.vue?vue&type=template&id=af4a87ae&scoped=true&"
import script from "./Aside.vue?vue&type=script&lang=ts&"
export * from "./Aside.vue?vue&type=script&lang=ts&"
import style0 from "./Aside.vue?vue&type=style&index=0&id=af4a87ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4a87ae",
  null
  
)

export default component.exports